import { apiSlice } from "./apiSlice";

export const publicationApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({

        getPublications: builder.query({
            query: () => `/publications`,
            providesTags: () => {
                return [{ type: "Publications" }];
            },
        }),

        submitDOI: builder.mutation({
            query: data => ({
                url: '/publications/publicationFromDOI',
                method: 'POST',
                body: { ...data }
            }),
        }),

        submitPublication: builder.mutation({
            query: data => ({
                url: '/publications/save',
                method: 'POST',
                body: { ...data }
            }),
            invalidatesTags: () => [{ type: "Publications" }]
        }),

    })
})

export const {
    useGetPublicationsQuery,
    useSubmitDOIMutation,
    useSubmitPublicationMutation
} = publicationApiSlice;